import React from 'react';
import type ProjectSettingsServiceDeskAutomationViewLogType from '@atlassian/jira-spa-apps-project-settings-service-desk-automation-view-log/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationViewLog = lazyForPaint<
	typeof ProjectSettingsServiceDeskAutomationViewLogType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-view-log", jiraSpaEntry: "async-project-settings-service-desk-automation-view-log" */ '@atlassian/jira-spa-apps-project-settings-service-desk-automation-view-log'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationViewLog}
		pageId="project-settings-automation-view-log"
		shouldShowSpinner
	/>
);
